// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================
   ADMIN LOGIN PAGE
========================================= */
 
.admin-login-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
 
  background: #e7f3fc;
 
  overflow: hidden;
}
 
 
/* =========================================
   LEFT IMAGE
========================================= */
 
.admin-login-image {
  width: 55%;
  height: 100vh;
 
  position: relative;
 
  display: flex;
  align-items: center;
  justify-content: center;
 
  overflow: hidden;
}
 
.admin-login-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.login-image-overlay {
  position: absolute;
 
  top: 0;
  left: 0;
 
  width: 100%;
  height: 100%;
 
 
 
  z-index: 1;
}
.login-side-content {
  position: absolute;
 
  top: 18%;
  left: 15%;
 
  width: 70%;
 
  z-index: 2;
 
  color: white;
}
 
.login-side-content h2 {
  margin: 0 0 28px 0;
 
  color: white;
 
  font-size: 23px;
 
  font-weight: 700;
 
  line-height: 1.3;
}
.security-point {
  display: flex;
 
  align-items: flex-start;
 
  gap: 14px;
 
  margin-bottom: 20px;
}
 
.security-point .arrow {
  font-size: 32px;
 
  line-height: 22px;
 
  font-weight: bold;
 
  color: white;
 
  flex-shrink: 0;
}
 
.security-point p {
  margin: 0;
 
  color: white;
 
  font-size: 15px;
 
  line-height: 1.28;
 
  font-weight: 400;
  margin-bottom: 10px;
}
.login-side-footer {
  position: absolute;
 
  left: 10%;
  bottom: 4%;
 
  width: 80%;
 
  z-index: 2;
 
  text-align: center;
 
  color: white;
}
 
.login-side-footer p {
  margin: 0;
 
  color: white;
 
  font-size: 13px;
 
  line-height: 1.3;
}
 
.login-side-footer span {
  color: #ffd000;
}
 
/* =========================================
   RIGHT SIDE
========================================= */
 
.admin-login-form-container {
  width: 45%;
  min-height: 100vh;
 
  display: flex;
  align-items: center;
  justify-content: center;
 
  padding: 30px 50px;
 
  background: #e7f3fc;
}
 
 
/* =========================================
   LOGIN CARD
========================================= */
 
.admin-login-form {
  width: 100%;
  max-width: 400px;
 
  background: #f5f8fd;
 
  border-radius: 24px;
 
  overflow: hidden;
 
  box-shadow:
    0 5px 15px rgba(0, 0, 0, 0.22);
 
  padding: 0;
}
 
 
/* =========================================
   HEADER
========================================= */
 
.login-header {
  position: relative;
 
  width: 100%;
  height: 105px;
 
  background:
    linear-gradient(
      175deg,
      #00549b 0%,
      #00549b 65%,
      #003f82 65%,
      #003f82 100%
    );
 
  overflow: hidden;
}
 
 
/* Orange curved bottom */
 
.login-header::after {
  content: "";
 
  position: absolute;
 
  left: -5%;
  bottom: -32px;
 
  width: 110%;
  height: 65px;
 
  background: #f58220;
 
  border-radius: 50% 50% 0 0 / 100% 100% 0 0;
 
  transform: rotate(-1deg);
}
 
 
/* Blue curve over orange */
 
.login-header::before {
  content: "";
 
  position: absolute;
 
  left: -5%;
  bottom: -18px;
 
  width: 110%;
  height: 42px;
 
  background: #f5f8fd;
 
  border-radius: 50% 50% 0 0 / 100% 100% 0 0;
 
  z-index: 2;
}
 
 
/* =========================================
   LOGO + TITLE
========================================= */
 
.login-logo-section {
  position: relative;
 
  z-index: 5;
 
  height: 75px;
 
  display: flex;
  align-items: center;
 
  padding: 10px 22px;
}
 
.login-logo {
  width: 45px;
  height: 45px;
 
  object-fit: contain;
 
  margin-right: 10px;
}
 
.login-title {
  color: white;
 
  font-size: 20px;
 
  font-weight: 700;
 
  line-height: 1.2;
 
  white-space: nowrap;
}
 
.login-title span {
  display: block;
 
  font-size: 11px;
 
  font-weight: 400;
 
  margin-top: 3px;
}
 
 
/* =========================================
   FORM CONTENT
========================================= */
 
.login-content {
  padding: 32px 42px 28px;
}
 
 
/* =========================================
   HEADING
========================================= */
 
.login-heading {
  text-align: center;
 
  margin-bottom: 25px;
}
 
.login-heading h2 {
  margin: 0;
 
  color: #111;
 
  font-size: 28px;
 
  font-weight: 700;
}
 
.login-heading p {
  margin: 4px 0 0;
 
  color: #999;
 
  font-size: 14px;
}
 
 
/* =========================================
   FORM FIELD
========================================= */
 
.login-field {
  margin-bottom: 18px;
}
 
.login-field label {
  display: block;
 
  margin-bottom: 8px;
 
  color: #111;
 
  font-size: 17px;
 
  font-weight: 700;
}
 
 
/* =========================================
   INPUT WRAPPER
========================================= */
 
/* INPUT BOX */
/* =========================================
   INPUT BOX
========================================= */
 
.input-wrapper {
  position: relative !important;
 
  width: 100%;
  height: 47px;
 
  display: block !important;
 
  background: #f8fbff;
 
  border: 1px solid #c8d9eb;
  border-radius: 9px;
 
  box-sizing: border-box;
}
 
 
/* =========================================
   LEFT ICON
========================================= */
 
.input-wrapper .input-icon {
  position: absolute !important;
 
  left: 14px !important;
  top: 61% !important;
 
  transform: translateY(-50%) !important;
 
  width: auto !important;
  min-width: 0 !important;
 
  margin: 0 !important;
  padding: 0 !important;
 
  color: #8a8a8a !important;
 
  font-size: 14px !important;
 
  z-index: 5;
 
  pointer-events: none;
}
 
 
/* =========================================
   INPUT
========================================= */
 
.input-wrapper .login-input {

  position: absolute !important;
 
  left: 42px !important;
  top: 0 !important;
 
  width: calc(100% - 82px) !important;
  height: 100% !important;
 
  margin: 0 !important;
 
  padding: 0 !important;
 
  border: none !important;
  outline: none !important;
 
  background: transparent !important;
 
  box-shadow: none !important;
 
  color: #333 !important;
 
  font-size: 15px !important;
 
  box-sizing: border-box !important;
}
 
 
/* =========================================
   PLACEHOLDER
========================================= */
 
.input-wrapper .login-input::placeholder {
  color: #8d8d8d !important;
 
  font-size: 12px !important;
 
  opacity: 1;
}
 
 
/* =========================================
   PASSWORD EYE
========================================= */
 
.input-wrapper .password-eye {
  position: absolute !important;
 
  right: 14px !important;
  top: 50% !important;
 
  left: auto !important;
 
  transform: translateY(-50%) !important;
 
  width: auto !important;
 
  margin: 0 !important;
  padding: 0 !important;
 
  color: #111 !important;
 
  font-size: 16px !important;
 
  cursor: pointer;
 
  z-index: 10;
}
/* =========================================
   OPTIONS
========================================= */
 
.login-options {
  display: flex;
 
  align-items: center;
 
  justify-content: space-between;
 
  margin-top: 2px;
 
  margin-bottom: 25px;
}
 
.remember-box {
  display: flex;
 
  align-items: center;
 
  gap: 8px;
 
  margin: 0;
margin-top: 10px;
  color: #222;
 
  font-size: 12px;
 
  cursor: pointer;
}
 
.remember-box input {
  width: 21px;
  height: 21px;
 
  margin: 0;
 
  cursor: pointer;
 
  accent-color: #0067ab;
}
 
.remember-box span {
  white-space: nowrap;
}
 
.forgot-password {
  color: #0071bd;
 
  font-size: 14px;
 
  text-decoration: none;
}
 
.forgot-password:hover {
  text-decoration: underline;
}
 
 
/* =========================================
   LOGIN BUTTON
========================================= */
 
.login-button-container {
  display: flex;
 
  justify-content: center;
 
  margin-top: 5px;
}
 
.admin-login-btn {
  width: 100%;
  height: 44px;
 
  border: none;
 
  border-radius: 10px;
 
  background:
    linear-gradient(
      to right,
      #005ba4,
      #006db1,
      #0085c5
    );
 
  color: white;
 
  font-size: 18px;
 
  font-weight: 600;
 
  cursor: pointer;
 
  display: flex;
 
  align-items: center;
 
  justify-content: center;
 
  gap: 7px;
 
  transition: all 0.2s ease;
}
 
.admin-login-btn:hover {
  transform: translateY(-1px);
 
  box-shadow:
    0 4px 10px rgba(0, 91, 164, 0.25);
}
 
.admin-login-btn:active {
  transform: translateY(0);
}
 
.admin-login-btn i {
  font-size: 14px;
}
 
 
/* =========================================
   NOTE
========================================= */
 
.login-note {
  display: flex;
 
  justify-content: center;
 
  align-items: center;
 
  gap: 5px;
 
  margin-top: 18px;
 
  color: #222;
 
  font-size: 10px;
 
  text-align: center;
}
 
.login-note i {
  color: #0075c1;
 
  font-size: 1px;
}
 
 
/* =========================================
   RESPONSIVE
========================================= */
 
@media (max-width: 1000px) {
 
  .admin-login-image {
    width: 50%;
  }
 
  .admin-login-form-container {
    width: 50%;
 
    padding: 25px;
  }
 
  .login-content {
    padding: 30px;
  }
 
  .login-title {
    font-size: 16px;
  }
}
 
 
@media (max-width: 768px) {
 
  .admin-login-container {
    min-height: 100vh;
 
    flex-direction: column;
 
    overflow-y: auto;
  }
 
  .admin-login-image {
    width: 100%;
 
    height: auto;
 
    max-height: 380px;
  }
 
  .admin-login-img {
    width: 100%;
 
    height: auto;
 
    max-height: 380px;
 
    object-fit: cover;
  }
 
  .admin-login-form-container {
    width: 100%;
 
    min-height: auto;
 
    padding: 25px 15px 40px;
  }
 
  .admin-login-form {
    max-width: 430px;
  }
 
  .login-content {
    padding: 30px 25px;
  }
}
 
 
@media (max-width: 480px) {
 
  .admin-login-form-container {
    padding: 15px 10px 30px;
  }
 
  .login-header {
    height: 95px;
  }
 
  .login-logo-section {
    padding: 8px 15px;
  }
 
  .login-logo {
    width: 40px;
    height: 40px;
  }
 
  .login-title {
    font-size: 15px;
  }
 
  .login-title span {
    font-size: 6px;
  }
 
  .login-content {
    padding: 25px 20px;
  }
 
  .login-heading h2 {
    font-size: 21px;
  }
 
  .login-options {
    gap: 10px;
  }
 
  .remember-box {
    font-size: 11px;
  }
 
  .forgot-password {
    font-size: 11px;
  }
}
 



.sidebar-logout-btn {
  width: 160px;
  height: 46px;
  border: none;
  border-radius: 24px;
 
  background: linear-gradient(to right, #ff554d, #ffad00) !important;
 
  color: white !important;
 
  font-size: 15px;
  font-weight: 600;
 
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
 
  cursor: pointer;
  padding: 0;
}

.showpanel {
  width: 18.5rem !important;
  min-width: 18.5rem !important;
  transition: all 0.3s ease;
  overflow: hidden;
}
 
/* SIDEBAR HIDE */
.panel {
  width: 0 !important;
  min-width: 0 !important;
  transition: all 0.3s ease;
  overflow: hidden;
}



/* ===== SIDEBAR CONTAINER ===== */
.sidebar-container {
  width: 18.5rem;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(to bottom, #0a4a8f 0%, #0d6bb8 55%, #1a8ad4 100%);
  overflow-y: auto;
  padding-bottom: 10px;
padding: 14px 8px 12px 10px;
}

.sidebar-logo {
  display: block;
  margin: 0 auto;
}

/* ===== MENU LIST ===== */
.sidebar-container ul.list-group {
  list-style: none;
  margin: 0;
  padding: 14px 8px 12px 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.sidebar-container ul {
  list-style: none;
  margin: 0;
padding: 14px 8px 12px 10px;
}

.sidebar-menu-item {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* ===== MENU ROW ===== */
.sidebar-container .sidebar-menu-link {
 position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    gap: 14px;
    min-height: 46px;
    padding: 13px 13px;
    border-radius: 7px;
    background: rgba(0, 70, 130, 0.18);
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
    border: 1px solid transparent;
    transition: background 0.22s ease, transform 0.18s ease, box-shadow 0.22s ease, border-color 0.22s ease;
}

.sidebar-container .sidebar-menu-link:hover {
  background: rgba(3, 40, 100, 0.8);
}

/* Active row (darker navy + left accent) */
.sidebar-container .sidebar-menu-link.active {
  background: #06306f;
  border-left: 3px solid #4db3ff;
}

.sidebar-menu-icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
  flex-shrink: 0;
  filter: brightness(0) invert(1); /* makes every icon white */
}

.sidebar-menu-text {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-menu-arrow {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

/* ===== SUBMENU ===== */
.sidebar-submenu {
  list-style: none;
  margin: 6px 0 0 !important;
  padding: 0 0 0 14px !important;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.sidebar-submenu .sidebar-menu-link {
  height: 34px;
  font-size: 12px;
  background: rgba(3, 40, 100, 0.4);
}

/* ===== LOGOUT BUTTON ===== */
.sidebar-logout-container {
  display: flex;
  justify-content: center;
  margin: 18px 0 10px;
}

.sidebar-container .sidebar-logout-btn {
  width: 100px;
  height: 40px;
  border: none;
  border-radius: 6px;
  background: linear-gradient(to bottom, #ffa63d, #f57c00) !important;
  color: #fff !important;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  padding: 0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
}

.sidebar-container .sidebar-logout-btn:hover {
  filter: brightness(1.08);
}

/* ===== BOTTOM WAVE ===== */
.sidebar-bottom-wave {
  margin-top: auto;
}

/* ===== LOADER ===== */
.loader {
  margin: 20px auto;
  width: 28px;
  height: 28px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }



/* =====================================
   SIDEBAR - REFERENCE DESIGN
===================================== */

/* SIDEBAR WIDTH */
.showpanel {
  width: 17.5rem !important;
  min-width: 17.5rem !important;
  flex-shrink: 0 !important;
  overflow: hidden;
}

.panel {
  width: 0 !important;
  min-width: 0 !important;
  overflow: hidden;
}

/* MAIN SIDEBAR */
.sidebar-container {
  width: 17.5rem !important;
  min-width: 17.5rem !important;
  height: 100vh !important;
  display: flex !important;
  flex-direction: column !important;
  background: linear-gradient(
    180deg,
    #2464ad 0%,
    #1478bd 55%,
    #078bc9 100%
  ) !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  padding: 0 0 12px !important;
  box-sizing: border-box !important;
}

/* LOGO SECTION */
.sidebar-logo-wrapper {
  width: 100%;
  min-height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 0 8px;
  box-sizing: border-box;
}

.sidebar-logo {
   object-fit: contain !important;
  display: block;
}

/* MENU LIST */
.sidebar-container .sidebar-menu-list {
  list-style: none !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 7px !important;
  padding: 5px 20px 0 !important;
  margin: 0 !important;
  border: none !important;
  background: transparent !important;
}

/* MENU ITEM */
.sidebar-menu-item {
  width: 100%;
  margin: 0 !important;
  padding: 0 !important;
  list-style: none !important;
}

/* MENU LINK */
.sidebar-container .sidebar-menu-link {
  width: 100% !important;
  height: 48px !important;
  min-height: 48px !important;
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  padding: 0 13px !important;
  box-sizing: border-box !important;

  background: rgba(0, 76, 145, 0.32) !important;
  border: none !important;
  border-radius: 10px !important;

  color: #ffffff !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  text-decoration: none !important;

  cursor: pointer;
  transition: all 0.2s ease;
}

/* HOVER */
.sidebar-container .sidebar-menu-link:hover {
  background: rgba(0, 57, 117, 0.55) !important;
  transform: translateX(2px);
}

/* ACTIVE MENU */
.sidebar-container .sidebar-menu-link.active {
  background: #075a9d !important;
  border-left: 4px solid #ffffff !important;
  padding-left: 9px !important;
  color: #ffffff !important;
  box-shadow: 0 2px 7px rgba(0, 35, 85, 0.15);
}

/* ICON */
.sidebar-menu-icon {
  width: 20px !important;
  height: 20px !important;
  min-width: 20px !important;
  object-fit: contain !important;
  flex-shrink: 0 !important;
  filter: brightness(0) invert(1) !important;
}

/* MENU TEXT */
.sidebar-menu-text {
  flex: 1 1;
  color: #ffffff !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ARROW */
.sidebar-menu-arrow {
  width: 15px !important;
  height: 15px !important;
  flex-shrink: 0;
}

/* SUBMENU */
.sidebar-container .sidebar-submenu {
  display: flex !important;
  flex-direction: column !important;
  gap: 6px !important;
      margin: 3px 7px 15px 30px !important;
  padding: 0 0 0 13px !important;
}

.sidebar-container .sidebar-submenu .sidebar-menu-link {
  height: 42px !important;
  min-height: 42px !important;
  font-size: 12px !important;
  background: rgba(0, 55, 115, 0.30) !important;
  border-radius: 8px !important;
}

/* LOGOUT */
.sidebar-logout-container {
  margin: 18px 0 12px !important;
  display: flex;
  justify-content: center;
}

/* SCROLLBAR */
.sidebar-container::-webkit-scrollbar {
  width: 5px;
}

.sidebar-container::-webkit-scrollbar-thumb {
  background: rgba(255,255,255,0.4);
  border-radius: 10px;
}

.sidebar-container::-webkit-scrollbar-track {
  background: transparent;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .showpanel {
    width: 17.5rem !important;
    min-width: 17.5rem !important;
  }
}



/* =================================
   EXPANDED SIDEBAR MENU
================================= */

/* Parent menu */
.sidebar-container .sidebar-parent-link {
  position: relative;
  background: rgba(0, 76, 145, 0.32) !important;
  border: 1px solid transparent !important;
  border-radius: 10px !important;
}

/* Expanded parent */
.sidebar-container .sidebar-parent-link.expanded {
  background: #0870b4 !important;
  border: 1px solid rgba(255,255,255,0.12) !important;
  border-radius: 10px !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
}

/* Arrow */
.sidebar-menu-arrow {
  width: 15px !important;
  height: 15px !important;
  margin-left: auto;
  transition: transform 0.25s ease;
}

.sidebar-menu-arrow.rotated {
  transform: rotate(90deg);
}

/* Submenu container */
.sidebar-container .sidebar-submenu {
  position: relative;
  list-style: none !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 0 !important;
      margin: 3px 7px 15px 30px !important;
  padding: 0 0 0 13px !important;
}

/* Vertical line */
.sidebar-container .sidebar-submenu::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 2px;
  background: rgba(255,255,255,0.25);
  border-radius: 2px;
}

/* Submenu item */
.sidebar-container .sidebar-submenu .sidebar-menu-link {
  height: 36px !important;
  min-height: 36px !important;
  padding: 0 9px !important;
  border-radius: 0 !important;
  background: transparent !important;
  border: none !important;
  font-size: 12px !important;
  font-weight: 500 !important;
}

/* Submenu hover */
.sidebar-container .sidebar-submenu .sidebar-menu-link:hover {
  background: rgba(0, 55, 110, 0.3) !important;
  border-radius: 5px !important;
}

/* Submenu active */
.sidebar-container .sidebar-submenu .sidebar-menu-link.active {
  background: rgba(0, 55, 110, 0.35) !important;
  border-left: 2px solid white !important;
  padding-left: 7px !important;
}

/* Hide submenu icons if reference has text-only submenu */
.sidebar-container .sidebar-submenu .sidebar-menu-icon {
  display: none !important;
}

/* Logo should not shrink when submenu opens */
.sidebar-logo-wrapper {
  flex-shrink: 0 !important;
  min-height: 140px !important;
}


/* Show complete sidebar menu text */
.sidebar-container .sidebar-menu-text {
  flex: 1 1;
  min-width: 0;

  color: #ffffff !important;
  font-size: 13px !important;
  font-weight: 600 !important;

  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;

  line-height: 1.3;
  overflow-wrap: break-word;
}

/* Allow menu items to expand for wrapped text */
.sidebar-container .sidebar-menu-link {
  height: auto !important;
  min-height: 48px !important;

  padding: 9px 13px !important;

  box-sizing: border-box !important;
}

/* Keep icons aligned */
.sidebar-container .sidebar-menu-icon {
  flex-shrink: 0 !important;
}

/* Keep arrow at the right */
.sidebar-container .sidebar-menu-arrow {
  flex-shrink: 0 !important;
  margin-left: auto;
}


/* Center menu tabs horizontally */
.sidebar-container .sidebar-menu-list {
  padding-left: 0 !important;
  padding-right: 0 !important;

  align-items: center !important;
}

/* Center each menu tab */
.sidebar-container .sidebar-menu-item {
  width: 86% !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

/* Keep menu content aligned inside the tab */
.sidebar-container .sidebar-menu-link {
  width: 100% !important;
  margin: 0 !important;
  box-sizing: border-box !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/admin/admin.css"],"names":[],"mappings":"AAAA;;2CAE2C;;AAE3C;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;;EAEb,mBAAmB;;EAEnB,gBAAgB;AAClB;;;AAGA;;2CAE2C;;AAE3C;EACE,UAAU;EACV,aAAa;;EAEb,kBAAkB;;EAElB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;;EAElB,MAAM;EACN,OAAO;;EAEP,WAAW;EACX,YAAY;;;;EAIZ,UAAU;AACZ;AACA;EACE,kBAAkB;;EAElB,QAAQ;EACR,SAAS;;EAET,UAAU;;EAEV,UAAU;;EAEV,YAAY;AACd;;AAEA;EACE,kBAAkB;;EAElB,YAAY;;EAEZ,eAAe;;EAEf,gBAAgB;;EAEhB,gBAAgB;AAClB;AACA;EACE,aAAa;;EAEb,uBAAuB;;EAEvB,SAAS;;EAET,mBAAmB;AACrB;;AAEA;EACE,eAAe;;EAEf,iBAAiB;;EAEjB,iBAAiB;;EAEjB,YAAY;;EAEZ,cAAc;AAChB;;AAEA;EACE,SAAS;;EAET,YAAY;;EAEZ,eAAe;;EAEf,iBAAiB;;EAEjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;;EAElB,SAAS;EACT,UAAU;;EAEV,UAAU;;EAEV,UAAU;;EAEV,kBAAkB;;EAElB,YAAY;AACd;;AAEA;EACE,SAAS;;EAET,YAAY;;EAEZ,eAAe;;EAEf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;2CAE2C;;AAE3C;EACE,UAAU;EACV,iBAAiB;;EAEjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,kBAAkB;;EAElB,mBAAmB;AACrB;;;AAGA;;2CAE2C;;AAE3C;EACE,WAAW;EACX,gBAAgB;;EAEhB,mBAAmB;;EAEnB,mBAAmB;;EAEnB,gBAAgB;;EAEhB;kCACgC;;EAEhC,UAAU;AACZ;;;AAGA;;2CAE2C;;AAE3C;EACE,kBAAkB;;EAElB,WAAW;EACX,aAAa;;EAEb;;;;;;;KAOG;;EAEH,gBAAgB;AAClB;;;AAGA,yBAAyB;;AAEzB;EACE,WAAW;;EAEX,kBAAkB;;EAElB,SAAS;EACT,aAAa;;EAEb,WAAW;EACX,YAAY;;EAEZ,mBAAmB;;EAEnB,0CAA0C;;EAE1C,wBAAwB;AAC1B;;;AAGA,2BAA2B;;AAE3B;EACE,WAAW;;EAEX,kBAAkB;;EAElB,SAAS;EACT,aAAa;;EAEb,WAAW;EACX,YAAY;;EAEZ,mBAAmB;;EAEnB,0CAA0C;;EAE1C,UAAU;AACZ;;;AAGA;;2CAE2C;;AAE3C;EACE,kBAAkB;;EAElB,UAAU;;EAEV,YAAY;;EAEZ,aAAa;EACb,mBAAmB;;EAEnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,mBAAmB;;EAEnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;;EAEZ,eAAe;;EAEf,gBAAgB;;EAEhB,gBAAgB;;EAEhB,mBAAmB;AACrB;;AAEA;EACE,cAAc;;EAEd,eAAe;;EAEf,gBAAgB;;EAEhB,eAAe;AACjB;;;AAGA;;2CAE2C;;AAE3C;EACE,uBAAuB;AACzB;;;AAGA;;2CAE2C;;AAE3C;EACE,kBAAkB;;EAElB,mBAAmB;AACrB;;AAEA;EACE,SAAS;;EAET,WAAW;;EAEX,eAAe;;EAEf,gBAAgB;AAClB;;AAEA;EACE,eAAe;;EAEf,WAAW;;EAEX,eAAe;AACjB;;;AAGA;;2CAE2C;;AAE3C;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;;EAEd,kBAAkB;;EAElB,WAAW;;EAEX,eAAe;;EAEf,gBAAgB;AAClB;;;AAGA;;2CAE2C;;AAE3C,cAAc;AACd;;2CAE2C;;AAE3C;EACE,6BAA6B;;EAE7B,WAAW;EACX,YAAY;;EAEZ,yBAAyB;;EAEzB,mBAAmB;;EAEnB,yBAAyB;EACzB,kBAAkB;;EAElB,sBAAsB;AACxB;;;AAGA;;2CAE2C;;AAE3C;EACE,6BAA6B;;EAE7B,qBAAqB;EACrB,mBAAmB;;EAEnB,sCAAsC;;EAEtC,sBAAsB;EACtB,uBAAuB;;EAEvB,oBAAoB;EACpB,qBAAqB;;EAErB,yBAAyB;;EAEzB,0BAA0B;;EAE1B,UAAU;;EAEV,oBAAoB;AACtB;;;AAGA;;2CAE2C;;AAE3C;;EAEE,6BAA6B;;EAE7B,qBAAqB;EACrB,iBAAiB;;EAEjB,mCAAmC;EACnC,uBAAuB;;EAEvB,oBAAoB;;EAEpB,qBAAqB;;EAErB,uBAAuB;EACvB,wBAAwB;;EAExB,kCAAkC;;EAElC,2BAA2B;;EAE3B,sBAAsB;;EAEtB,0BAA0B;;EAE1B,iCAAiC;AACnC;;;AAGA;;2CAE2C;;AAE3C;EACE,yBAAyB;;EAEzB,0BAA0B;;EAE1B,UAAU;AACZ;;;AAGA;;2CAE2C;;AAE3C;EACE,6BAA6B;;EAE7B,sBAAsB;EACtB,mBAAmB;;EAEnB,qBAAqB;;EAErB,sCAAsC;;EAEtC,sBAAsB;;EAEtB,oBAAoB;EACpB,qBAAqB;;EAErB,sBAAsB;;EAEtB,0BAA0B;;EAE1B,eAAe;;EAEf,WAAW;AACb;AACA;;2CAE2C;;AAE3C;EACE,aAAa;;EAEb,mBAAmB;;EAEnB,8BAA8B;;EAE9B,eAAe;;EAEf,mBAAmB;AACrB;;AAEA;EACE,aAAa;;EAEb,mBAAmB;;EAEnB,QAAQ;;EAER,SAAS;AACX,gBAAgB;EACd,WAAW;;EAEX,eAAe;;EAEf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,SAAS;;EAET,eAAe;;EAEf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;;EAEd,eAAe;;EAEf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;;2CAE2C;;AAE3C;EACE,aAAa;;EAEb,uBAAuB;;EAEvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,YAAY;;EAEZ,mBAAmB;;EAEnB;;;;;;KAMG;;EAEH,YAAY;;EAEZ,eAAe;;EAEf,gBAAgB;;EAEhB,eAAe;;EAEf,aAAa;;EAEb,mBAAmB;;EAEnB,uBAAuB;;EAEvB,QAAQ;;EAER,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;;EAE3B;qCACmC;AACrC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;;AAGA;;2CAE2C;;AAE3C;EACE,aAAa;;EAEb,uBAAuB;;EAEvB,mBAAmB;;EAEnB,QAAQ;;EAER,gBAAgB;;EAEhB,WAAW;;EAEX,eAAe;;EAEf,kBAAkB;AACpB;;AAEA;EACE,cAAc;;EAEd,cAAc;AAChB;;;AAGA;;2CAE2C;;AAE3C;;EAEE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;;IAEV,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA;;EAEE;IACE,iBAAiB;;IAEjB,sBAAsB;;IAEtB,gBAAgB;EAClB;;EAEA;IACE,WAAW;;IAEX,YAAY;;IAEZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;;IAEX,YAAY;;IAEZ,iBAAiB;;IAEjB,iBAAiB;EACnB;;EAEA;IACE,WAAW;;IAEX,gBAAgB;;IAEhB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF;;;AAGA;;EAEE;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;;;;AAKA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;;EAEnB,kEAAkE;;EAElE,uBAAuB;;EAEvB,eAAe;EACf,gBAAgB;;EAEhB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;;EAER,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;;;AAIA,kCAAkC;AAClC;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,6EAA6E;EAC7E,gBAAgB;EAChB,oBAAoB;AACtB,2BAA2B;AAC3B;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX,2BAA2B;AAC3B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA,yBAAyB;AACzB;CACC,kBAAkB;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kCAAkC;IAClC,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,6BAA6B;IAC7B,uGAAuG;AAC3G;;AAEA;EACE,iCAAiC;AACnC;;AAEA,2CAA2C;AAC3C;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,+BAA+B,EAAE,2BAA2B;AAC9D;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iCAAiC;AACnC;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mEAAmE;EACnE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,oCAAoC;AACtC;AACA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;;;AAIpD;;uCAEuC;;AAEvC,kBAAkB;AAClB;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,wBAAwB;EACxB,wBAAwB;EACxB,iCAAiC;EACjC;;;;;cAKY;EACZ,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;GACG,8BAA8B;EAC/B,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA,cAAc;AACd;EACE,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,0BAA0B;EAC1B,iCAAiC;;EAEjC,6CAA6C;EAC7C,uBAAuB;EACvB,8BAA8B;;EAE9B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,gCAAgC;;EAEhC,eAAe;EACf,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,4BAA4B;EAC5B,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA,SAAS;AACT;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,8BAA8B;EAC9B,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA,cAAc;AACd;EACE,SAAO;EACP,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;MACf,oCAAoC;EACxC,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,6CAA6C;EAC7C,6BAA6B;AAC/B;;AAEA,WAAW;AACX;EACE,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;AACzB;;AAEA,cAAc;AACd;EACE,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;AACF;;;;AAIA;;mCAEmC;;AAEnC,gBAAgB;AAChB;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,8BAA8B;EAC9B,mDAAmD;EACnD,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA,UAAU;AACV;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;EACjC,iBAAiB;MACb,oCAAoC;EACxC,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,kCAAkC;EAClC,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,4CAA4C;EAC5C,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,6CAA6C;EAC7C,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA,0DAA0D;AAC1D;EACE,wBAAwB;AAC1B;;AAEA,8CAA8C;AAC9C;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;;AAGA,oCAAoC;AACpC;EACE,SAAO;EACP,YAAY;;EAEZ,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;;EAE3B,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;;EAE/B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,gDAAgD;AAChD;EACE,uBAAuB;EACvB,2BAA2B;;EAE3B,4BAA4B;;EAE5B,iCAAiC;AACnC;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;;AAGA,kCAAkC;AAClC;EACE,0BAA0B;EAC1B,2BAA2B;;EAE3B,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,6CAA6C;AAC7C;EACE,sBAAsB;EACtB,oBAAoB;EACpB,iCAAiC;AACnC","sourcesContent":["/* =========================================\r\n   ADMIN LOGIN PAGE\r\n========================================= */\r\n \r\n.admin-login-container {\r\n  width: 100%;\r\n  min-height: 100vh;\r\n  display: flex;\r\n \r\n  background: #e7f3fc;\r\n \r\n  overflow: hidden;\r\n}\r\n \r\n \r\n/* =========================================\r\n   LEFT IMAGE\r\n========================================= */\r\n \r\n.admin-login-image {\r\n  width: 55%;\r\n  height: 100vh;\r\n \r\n  position: relative;\r\n \r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n \r\n  overflow: hidden;\r\n}\r\n \r\n.admin-login-img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  display: block;\r\n}\r\n.login-image-overlay {\r\n  position: absolute;\r\n \r\n  top: 0;\r\n  left: 0;\r\n \r\n  width: 100%;\r\n  height: 100%;\r\n \r\n \r\n \r\n  z-index: 1;\r\n}\r\n.login-side-content {\r\n  position: absolute;\r\n \r\n  top: 18%;\r\n  left: 15%;\r\n \r\n  width: 70%;\r\n \r\n  z-index: 2;\r\n \r\n  color: white;\r\n}\r\n \r\n.login-side-content h2 {\r\n  margin: 0 0 28px 0;\r\n \r\n  color: white;\r\n \r\n  font-size: 23px;\r\n \r\n  font-weight: 700;\r\n \r\n  line-height: 1.3;\r\n}\r\n.security-point {\r\n  display: flex;\r\n \r\n  align-items: flex-start;\r\n \r\n  gap: 14px;\r\n \r\n  margin-bottom: 20px;\r\n}\r\n \r\n.security-point .arrow {\r\n  font-size: 32px;\r\n \r\n  line-height: 22px;\r\n \r\n  font-weight: bold;\r\n \r\n  color: white;\r\n \r\n  flex-shrink: 0;\r\n}\r\n \r\n.security-point p {\r\n  margin: 0;\r\n \r\n  color: white;\r\n \r\n  font-size: 15px;\r\n \r\n  line-height: 1.28;\r\n \r\n  font-weight: 400;\r\n  margin-bottom: 10px;\r\n}\r\n.login-side-footer {\r\n  position: absolute;\r\n \r\n  left: 10%;\r\n  bottom: 4%;\r\n \r\n  width: 80%;\r\n \r\n  z-index: 2;\r\n \r\n  text-align: center;\r\n \r\n  color: white;\r\n}\r\n \r\n.login-side-footer p {\r\n  margin: 0;\r\n \r\n  color: white;\r\n \r\n  font-size: 13px;\r\n \r\n  line-height: 1.3;\r\n}\r\n \r\n.login-side-footer span {\r\n  color: #ffd000;\r\n}\r\n \r\n/* =========================================\r\n   RIGHT SIDE\r\n========================================= */\r\n \r\n.admin-login-form-container {\r\n  width: 45%;\r\n  min-height: 100vh;\r\n \r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n \r\n  padding: 30px 50px;\r\n \r\n  background: #e7f3fc;\r\n}\r\n \r\n \r\n/* =========================================\r\n   LOGIN CARD\r\n========================================= */\r\n \r\n.admin-login-form {\r\n  width: 100%;\r\n  max-width: 400px;\r\n \r\n  background: #f5f8fd;\r\n \r\n  border-radius: 24px;\r\n \r\n  overflow: hidden;\r\n \r\n  box-shadow:\r\n    0 5px 15px rgba(0, 0, 0, 0.22);\r\n \r\n  padding: 0;\r\n}\r\n \r\n \r\n/* =========================================\r\n   HEADER\r\n========================================= */\r\n \r\n.login-header {\r\n  position: relative;\r\n \r\n  width: 100%;\r\n  height: 105px;\r\n \r\n  background:\r\n    linear-gradient(\r\n      175deg,\r\n      #00549b 0%,\r\n      #00549b 65%,\r\n      #003f82 65%,\r\n      #003f82 100%\r\n    );\r\n \r\n  overflow: hidden;\r\n}\r\n \r\n \r\n/* Orange curved bottom */\r\n \r\n.login-header::after {\r\n  content: \"\";\r\n \r\n  position: absolute;\r\n \r\n  left: -5%;\r\n  bottom: -32px;\r\n \r\n  width: 110%;\r\n  height: 65px;\r\n \r\n  background: #f58220;\r\n \r\n  border-radius: 50% 50% 0 0 / 100% 100% 0 0;\r\n \r\n  transform: rotate(-1deg);\r\n}\r\n \r\n \r\n/* Blue curve over orange */\r\n \r\n.login-header::before {\r\n  content: \"\";\r\n \r\n  position: absolute;\r\n \r\n  left: -5%;\r\n  bottom: -18px;\r\n \r\n  width: 110%;\r\n  height: 42px;\r\n \r\n  background: #f5f8fd;\r\n \r\n  border-radius: 50% 50% 0 0 / 100% 100% 0 0;\r\n \r\n  z-index: 2;\r\n}\r\n \r\n \r\n/* =========================================\r\n   LOGO + TITLE\r\n========================================= */\r\n \r\n.login-logo-section {\r\n  position: relative;\r\n \r\n  z-index: 5;\r\n \r\n  height: 75px;\r\n \r\n  display: flex;\r\n  align-items: center;\r\n \r\n  padding: 10px 22px;\r\n}\r\n \r\n.login-logo {\r\n  width: 45px;\r\n  height: 45px;\r\n \r\n  object-fit: contain;\r\n \r\n  margin-right: 10px;\r\n}\r\n \r\n.login-title {\r\n  color: white;\r\n \r\n  font-size: 20px;\r\n \r\n  font-weight: 700;\r\n \r\n  line-height: 1.2;\r\n \r\n  white-space: nowrap;\r\n}\r\n \r\n.login-title span {\r\n  display: block;\r\n \r\n  font-size: 11px;\r\n \r\n  font-weight: 400;\r\n \r\n  margin-top: 3px;\r\n}\r\n \r\n \r\n/* =========================================\r\n   FORM CONTENT\r\n========================================= */\r\n \r\n.login-content {\r\n  padding: 32px 42px 28px;\r\n}\r\n \r\n \r\n/* =========================================\r\n   HEADING\r\n========================================= */\r\n \r\n.login-heading {\r\n  text-align: center;\r\n \r\n  margin-bottom: 25px;\r\n}\r\n \r\n.login-heading h2 {\r\n  margin: 0;\r\n \r\n  color: #111;\r\n \r\n  font-size: 28px;\r\n \r\n  font-weight: 700;\r\n}\r\n \r\n.login-heading p {\r\n  margin: 4px 0 0;\r\n \r\n  color: #999;\r\n \r\n  font-size: 14px;\r\n}\r\n \r\n \r\n/* =========================================\r\n   FORM FIELD\r\n========================================= */\r\n \r\n.login-field {\r\n  margin-bottom: 18px;\r\n}\r\n \r\n.login-field label {\r\n  display: block;\r\n \r\n  margin-bottom: 8px;\r\n \r\n  color: #111;\r\n \r\n  font-size: 17px;\r\n \r\n  font-weight: 700;\r\n}\r\n \r\n \r\n/* =========================================\r\n   INPUT WRAPPER\r\n========================================= */\r\n \r\n/* INPUT BOX */\r\n/* =========================================\r\n   INPUT BOX\r\n========================================= */\r\n \r\n.input-wrapper {\r\n  position: relative !important;\r\n \r\n  width: 100%;\r\n  height: 47px;\r\n \r\n  display: block !important;\r\n \r\n  background: #f8fbff;\r\n \r\n  border: 1px solid #c8d9eb;\r\n  border-radius: 9px;\r\n \r\n  box-sizing: border-box;\r\n}\r\n \r\n \r\n/* =========================================\r\n   LEFT ICON\r\n========================================= */\r\n \r\n.input-wrapper .input-icon {\r\n  position: absolute !important;\r\n \r\n  left: 14px !important;\r\n  top: 61% !important;\r\n \r\n  transform: translateY(-50%) !important;\r\n \r\n  width: auto !important;\r\n  min-width: 0 !important;\r\n \r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n \r\n  color: #8a8a8a !important;\r\n \r\n  font-size: 14px !important;\r\n \r\n  z-index: 5;\r\n \r\n  pointer-events: none;\r\n}\r\n \r\n \r\n/* =========================================\r\n   INPUT\r\n========================================= */\r\n \r\n.input-wrapper .login-input {\r\n\r\n  position: absolute !important;\r\n \r\n  left: 42px !important;\r\n  top: 0 !important;\r\n \r\n  width: calc(100% - 82px) !important;\r\n  height: 100% !important;\r\n \r\n  margin: 0 !important;\r\n \r\n  padding: 0 !important;\r\n \r\n  border: none !important;\r\n  outline: none !important;\r\n \r\n  background: transparent !important;\r\n \r\n  box-shadow: none !important;\r\n \r\n  color: #333 !important;\r\n \r\n  font-size: 15px !important;\r\n \r\n  box-sizing: border-box !important;\r\n}\r\n \r\n \r\n/* =========================================\r\n   PLACEHOLDER\r\n========================================= */\r\n \r\n.input-wrapper .login-input::placeholder {\r\n  color: #8d8d8d !important;\r\n \r\n  font-size: 12px !important;\r\n \r\n  opacity: 1;\r\n}\r\n \r\n \r\n/* =========================================\r\n   PASSWORD EYE\r\n========================================= */\r\n \r\n.input-wrapper .password-eye {\r\n  position: absolute !important;\r\n \r\n  right: 14px !important;\r\n  top: 50% !important;\r\n \r\n  left: auto !important;\r\n \r\n  transform: translateY(-50%) !important;\r\n \r\n  width: auto !important;\r\n \r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n \r\n  color: #111 !important;\r\n \r\n  font-size: 16px !important;\r\n \r\n  cursor: pointer;\r\n \r\n  z-index: 10;\r\n}\r\n/* =========================================\r\n   OPTIONS\r\n========================================= */\r\n \r\n.login-options {\r\n  display: flex;\r\n \r\n  align-items: center;\r\n \r\n  justify-content: space-between;\r\n \r\n  margin-top: 2px;\r\n \r\n  margin-bottom: 25px;\r\n}\r\n \r\n.remember-box {\r\n  display: flex;\r\n \r\n  align-items: center;\r\n \r\n  gap: 8px;\r\n \r\n  margin: 0;\r\nmargin-top: 10px;\r\n  color: #222;\r\n \r\n  font-size: 12px;\r\n \r\n  cursor: pointer;\r\n}\r\n \r\n.remember-box input {\r\n  width: 21px;\r\n  height: 21px;\r\n \r\n  margin: 0;\r\n \r\n  cursor: pointer;\r\n \r\n  accent-color: #0067ab;\r\n}\r\n \r\n.remember-box span {\r\n  white-space: nowrap;\r\n}\r\n \r\n.forgot-password {\r\n  color: #0071bd;\r\n \r\n  font-size: 14px;\r\n \r\n  text-decoration: none;\r\n}\r\n \r\n.forgot-password:hover {\r\n  text-decoration: underline;\r\n}\r\n \r\n \r\n/* =========================================\r\n   LOGIN BUTTON\r\n========================================= */\r\n \r\n.login-button-container {\r\n  display: flex;\r\n \r\n  justify-content: center;\r\n \r\n  margin-top: 5px;\r\n}\r\n \r\n.admin-login-btn {\r\n  width: 100%;\r\n  height: 44px;\r\n \r\n  border: none;\r\n \r\n  border-radius: 10px;\r\n \r\n  background:\r\n    linear-gradient(\r\n      to right,\r\n      #005ba4,\r\n      #006db1,\r\n      #0085c5\r\n    );\r\n \r\n  color: white;\r\n \r\n  font-size: 18px;\r\n \r\n  font-weight: 600;\r\n \r\n  cursor: pointer;\r\n \r\n  display: flex;\r\n \r\n  align-items: center;\r\n \r\n  justify-content: center;\r\n \r\n  gap: 7px;\r\n \r\n  transition: all 0.2s ease;\r\n}\r\n \r\n.admin-login-btn:hover {\r\n  transform: translateY(-1px);\r\n \r\n  box-shadow:\r\n    0 4px 10px rgba(0, 91, 164, 0.25);\r\n}\r\n \r\n.admin-login-btn:active {\r\n  transform: translateY(0);\r\n}\r\n \r\n.admin-login-btn i {\r\n  font-size: 14px;\r\n}\r\n \r\n \r\n/* =========================================\r\n   NOTE\r\n========================================= */\r\n \r\n.login-note {\r\n  display: flex;\r\n \r\n  justify-content: center;\r\n \r\n  align-items: center;\r\n \r\n  gap: 5px;\r\n \r\n  margin-top: 18px;\r\n \r\n  color: #222;\r\n \r\n  font-size: 10px;\r\n \r\n  text-align: center;\r\n}\r\n \r\n.login-note i {\r\n  color: #0075c1;\r\n \r\n  font-size: 1px;\r\n}\r\n \r\n \r\n/* =========================================\r\n   RESPONSIVE\r\n========================================= */\r\n \r\n@media (max-width: 1000px) {\r\n \r\n  .admin-login-image {\r\n    width: 50%;\r\n  }\r\n \r\n  .admin-login-form-container {\r\n    width: 50%;\r\n \r\n    padding: 25px;\r\n  }\r\n \r\n  .login-content {\r\n    padding: 30px;\r\n  }\r\n \r\n  .login-title {\r\n    font-size: 16px;\r\n  }\r\n}\r\n \r\n \r\n@media (max-width: 768px) {\r\n \r\n  .admin-login-container {\r\n    min-height: 100vh;\r\n \r\n    flex-direction: column;\r\n \r\n    overflow-y: auto;\r\n  }\r\n \r\n  .admin-login-image {\r\n    width: 100%;\r\n \r\n    height: auto;\r\n \r\n    max-height: 380px;\r\n  }\r\n \r\n  .admin-login-img {\r\n    width: 100%;\r\n \r\n    height: auto;\r\n \r\n    max-height: 380px;\r\n \r\n    object-fit: cover;\r\n  }\r\n \r\n  .admin-login-form-container {\r\n    width: 100%;\r\n \r\n    min-height: auto;\r\n \r\n    padding: 25px 15px 40px;\r\n  }\r\n \r\n  .admin-login-form {\r\n    max-width: 430px;\r\n  }\r\n \r\n  .login-content {\r\n    padding: 30px 25px;\r\n  }\r\n}\r\n \r\n \r\n@media (max-width: 480px) {\r\n \r\n  .admin-login-form-container {\r\n    padding: 15px 10px 30px;\r\n  }\r\n \r\n  .login-header {\r\n    height: 95px;\r\n  }\r\n \r\n  .login-logo-section {\r\n    padding: 8px 15px;\r\n  }\r\n \r\n  .login-logo {\r\n    width: 40px;\r\n    height: 40px;\r\n  }\r\n \r\n  .login-title {\r\n    font-size: 15px;\r\n  }\r\n \r\n  .login-title span {\r\n    font-size: 6px;\r\n  }\r\n \r\n  .login-content {\r\n    padding: 25px 20px;\r\n  }\r\n \r\n  .login-heading h2 {\r\n    font-size: 21px;\r\n  }\r\n \r\n  .login-options {\r\n    gap: 10px;\r\n  }\r\n \r\n  .remember-box {\r\n    font-size: 11px;\r\n  }\r\n \r\n  .forgot-password {\r\n    font-size: 11px;\r\n  }\r\n}\r\n \r\n\r\n\r\n\r\n.sidebar-logout-btn {\r\n  width: 160px;\r\n  height: 46px;\r\n  border: none;\r\n  border-radius: 24px;\r\n \r\n  background: linear-gradient(to right, #ff554d, #ffad00) !important;\r\n \r\n  color: white !important;\r\n \r\n  font-size: 15px;\r\n  font-weight: 600;\r\n \r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n \r\n  cursor: pointer;\r\n  padding: 0;\r\n}\r\n\r\n.showpanel {\r\n  width: 18.5rem !important;\r\n  min-width: 18.5rem !important;\r\n  transition: all 0.3s ease;\r\n  overflow: hidden;\r\n}\r\n \r\n/* SIDEBAR HIDE */\r\n.panel {\r\n  width: 0 !important;\r\n  min-width: 0 !important;\r\n  transition: all 0.3s ease;\r\n  overflow: hidden;\r\n}\r\n\r\n\r\n\r\n/* ===== SIDEBAR CONTAINER ===== */\r\n.sidebar-container {\r\n  width: 18.5rem;\r\n  height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: linear-gradient(to bottom, #0a4a8f 0%, #0d6bb8 55%, #1a8ad4 100%);\r\n  overflow-y: auto;\r\n  padding-bottom: 10px;\r\npadding: 14px 8px 12px 10px;\r\n}\r\n\r\n.sidebar-logo {\r\n  display: block;\r\n  margin: 0 auto;\r\n}\r\n\r\n/* ===== MENU LIST ===== */\r\n.sidebar-container ul.list-group {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 14px 8px 12px 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.sidebar-container ul {\r\n  list-style: none;\r\n  margin: 0;\r\npadding: 14px 8px 12px 10px;\r\n}\r\n\r\n.sidebar-menu-item {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n/* ===== MENU ROW ===== */\r\n.sidebar-container .sidebar-menu-link {\r\n position: relative;\r\n    overflow: hidden;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 14px;\r\n    min-height: 46px;\r\n    padding: 13px 13px;\r\n    border-radius: 7px;\r\n    background: rgba(0, 70, 130, 0.18);\r\n    color: #ffffff;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n    border: 1px solid transparent;\r\n    transition: background 0.22s ease, transform 0.18s ease, box-shadow 0.22s ease, border-color 0.22s ease;\r\n}\r\n\r\n.sidebar-container .sidebar-menu-link:hover {\r\n  background: rgba(3, 40, 100, 0.8);\r\n}\r\n\r\n/* Active row (darker navy + left accent) */\r\n.sidebar-container .sidebar-menu-link.active {\r\n  background: #06306f;\r\n  border-left: 3px solid #4db3ff;\r\n}\r\n\r\n.sidebar-menu-icon {\r\n  width: 18px;\r\n  height: 18px;\r\n  object-fit: contain;\r\n  flex-shrink: 0;\r\n  filter: brightness(0) invert(1); /* makes every icon white */\r\n}\r\n\r\n.sidebar-menu-text {\r\n  flex: 1;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.sidebar-menu-arrow {\r\n  width: 14px;\r\n  height: 14px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* ===== SUBMENU ===== */\r\n.sidebar-submenu {\r\n  list-style: none;\r\n  margin: 6px 0 0 !important;\r\n  padding: 0 0 0 14px !important;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.sidebar-submenu .sidebar-menu-link {\r\n  height: 34px;\r\n  font-size: 12px;\r\n  background: rgba(3, 40, 100, 0.4);\r\n}\r\n\r\n/* ===== LOGOUT BUTTON ===== */\r\n.sidebar-logout-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin: 18px 0 10px;\r\n}\r\n\r\n.sidebar-container .sidebar-logout-btn {\r\n  width: 100px;\r\n  height: 40px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  background: linear-gradient(to bottom, #ffa63d, #f57c00) !important;\r\n  color: #fff !important;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.sidebar-container .sidebar-logout-btn:hover {\r\n  filter: brightness(1.08);\r\n}\r\n\r\n/* ===== BOTTOM WAVE ===== */\r\n.sidebar-bottom-wave {\r\n  margin-top: auto;\r\n}\r\n\r\n/* ===== LOADER ===== */\r\n.loader {\r\n  margin: 20px auto;\r\n  width: 28px;\r\n  height: 28px;\r\n  border: 3px solid rgba(255, 255, 255, 0.3);\r\n  border-top-color: #fff;\r\n  border-radius: 50%;\r\n  animation: spin 0.8s linear infinite;\r\n}\r\n@keyframes spin { to { transform: rotate(360deg); } }\r\n\r\n\r\n\r\n/* =====================================\r\n   SIDEBAR - REFERENCE DESIGN\r\n===================================== */\r\n\r\n/* SIDEBAR WIDTH */\r\n.showpanel {\r\n  width: 17.5rem !important;\r\n  min-width: 17.5rem !important;\r\n  flex-shrink: 0 !important;\r\n  overflow: hidden;\r\n}\r\n\r\n.panel {\r\n  width: 0 !important;\r\n  min-width: 0 !important;\r\n  overflow: hidden;\r\n}\r\n\r\n/* MAIN SIDEBAR */\r\n.sidebar-container {\r\n  width: 17.5rem !important;\r\n  min-width: 17.5rem !important;\r\n  height: 100vh !important;\r\n  display: flex !important;\r\n  flex-direction: column !important;\r\n  background: linear-gradient(\r\n    180deg,\r\n    #2464ad 0%,\r\n    #1478bd 55%,\r\n    #078bc9 100%\r\n  ) !important;\r\n  overflow-y: auto !important;\r\n  overflow-x: hidden !important;\r\n  padding: 0 0 12px !important;\r\n  box-sizing: border-box !important;\r\n}\r\n\r\n/* LOGO SECTION */\r\n.sidebar-logo-wrapper {\r\n  width: 100%;\r\n  min-height: 140px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 12px 0 8px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.sidebar-logo {\r\n   object-fit: contain !important;\r\n  display: block;\r\n}\r\n\r\n/* MENU LIST */\r\n.sidebar-container .sidebar-menu-list {\r\n  list-style: none !important;\r\n  display: flex !important;\r\n  flex-direction: column !important;\r\n  gap: 7px !important;\r\n  padding: 5px 20px 0 !important;\r\n  margin: 0 !important;\r\n  border: none !important;\r\n  background: transparent !important;\r\n}\r\n\r\n/* MENU ITEM */\r\n.sidebar-menu-item {\r\n  width: 100%;\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n  list-style: none !important;\r\n}\r\n\r\n/* MENU LINK */\r\n.sidebar-container .sidebar-menu-link {\r\n  width: 100% !important;\r\n  height: 48px !important;\r\n  min-height: 48px !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  gap: 12px !important;\r\n  padding: 0 13px !important;\r\n  box-sizing: border-box !important;\r\n\r\n  background: rgba(0, 76, 145, 0.32) !important;\r\n  border: none !important;\r\n  border-radius: 10px !important;\r\n\r\n  color: #ffffff !important;\r\n  font-size: 13px !important;\r\n  font-weight: 600 !important;\r\n  text-decoration: none !important;\r\n\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n/* HOVER */\r\n.sidebar-container .sidebar-menu-link:hover {\r\n  background: rgba(0, 57, 117, 0.55) !important;\r\n  transform: translateX(2px);\r\n}\r\n\r\n/* ACTIVE MENU */\r\n.sidebar-container .sidebar-menu-link.active {\r\n  background: #075a9d !important;\r\n  border-left: 4px solid #ffffff !important;\r\n  padding-left: 9px !important;\r\n  color: #ffffff !important;\r\n  box-shadow: 0 2px 7px rgba(0, 35, 85, 0.15);\r\n}\r\n\r\n/* ICON */\r\n.sidebar-menu-icon {\r\n  width: 20px !important;\r\n  height: 20px !important;\r\n  min-width: 20px !important;\r\n  object-fit: contain !important;\r\n  flex-shrink: 0 !important;\r\n  filter: brightness(0) invert(1) !important;\r\n}\r\n\r\n/* MENU TEXT */\r\n.sidebar-menu-text {\r\n  flex: 1;\r\n  color: #ffffff !important;\r\n  font-size: 14px !important;\r\n  font-weight: 600 !important;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n/* ARROW */\r\n.sidebar-menu-arrow {\r\n  width: 15px !important;\r\n  height: 15px !important;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* SUBMENU */\r\n.sidebar-container .sidebar-submenu {\r\n  display: flex !important;\r\n  flex-direction: column !important;\r\n  gap: 6px !important;\r\n      margin: 3px 7px 15px 30px !important;\r\n  padding: 0 0 0 13px !important;\r\n}\r\n\r\n.sidebar-container .sidebar-submenu .sidebar-menu-link {\r\n  height: 42px !important;\r\n  min-height: 42px !important;\r\n  font-size: 12px !important;\r\n  background: rgba(0, 55, 115, 0.30) !important;\r\n  border-radius: 8px !important;\r\n}\r\n\r\n/* LOGOUT */\r\n.sidebar-logout-container {\r\n  margin: 18px 0 12px !important;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n/* SCROLLBAR */\r\n.sidebar-container::-webkit-scrollbar {\r\n  width: 5px;\r\n}\r\n\r\n.sidebar-container::-webkit-scrollbar-thumb {\r\n  background: rgba(255,255,255,0.4);\r\n  border-radius: 10px;\r\n}\r\n\r\n.sidebar-container::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n/* RESPONSIVE */\r\n@media (max-width: 768px) {\r\n  .showpanel {\r\n    width: 17.5rem !important;\r\n    min-width: 17.5rem !important;\r\n  }\r\n}\r\n\r\n\r\n\r\n/* =================================\r\n   EXPANDED SIDEBAR MENU\r\n================================= */\r\n\r\n/* Parent menu */\r\n.sidebar-container .sidebar-parent-link {\r\n  position: relative;\r\n  background: rgba(0, 76, 145, 0.32) !important;\r\n  border: 1px solid transparent !important;\r\n  border-radius: 10px !important;\r\n}\r\n\r\n/* Expanded parent */\r\n.sidebar-container .sidebar-parent-link.expanded {\r\n  background: #0870b4 !important;\r\n  border: 1px solid rgba(255,255,255,0.12) !important;\r\n  border-radius: 10px !important;\r\n  box-shadow: 0 2px 6px rgba(0,0,0,0.08);\r\n}\r\n\r\n/* Arrow */\r\n.sidebar-menu-arrow {\r\n  width: 15px !important;\r\n  height: 15px !important;\r\n  margin-left: auto;\r\n  transition: transform 0.25s ease;\r\n}\r\n\r\n.sidebar-menu-arrow.rotated {\r\n  transform: rotate(90deg);\r\n}\r\n\r\n/* Submenu container */\r\n.sidebar-container .sidebar-submenu {\r\n  position: relative;\r\n  list-style: none !important;\r\n  display: flex !important;\r\n  flex-direction: column !important;\r\n  gap: 0 !important;\r\n      margin: 3px 7px 15px 30px !important;\r\n  padding: 0 0 0 13px !important;\r\n}\r\n\r\n/* Vertical line */\r\n.sidebar-container .sidebar-submenu::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  width: 2px;\r\n  background: rgba(255,255,255,0.25);\r\n  border-radius: 2px;\r\n}\r\n\r\n/* Submenu item */\r\n.sidebar-container .sidebar-submenu .sidebar-menu-link {\r\n  height: 36px !important;\r\n  min-height: 36px !important;\r\n  padding: 0 9px !important;\r\n  border-radius: 0 !important;\r\n  background: transparent !important;\r\n  border: none !important;\r\n  font-size: 12px !important;\r\n  font-weight: 500 !important;\r\n}\r\n\r\n/* Submenu hover */\r\n.sidebar-container .sidebar-submenu .sidebar-menu-link:hover {\r\n  background: rgba(0, 55, 110, 0.3) !important;\r\n  border-radius: 5px !important;\r\n}\r\n\r\n/* Submenu active */\r\n.sidebar-container .sidebar-submenu .sidebar-menu-link.active {\r\n  background: rgba(0, 55, 110, 0.35) !important;\r\n  border-left: 2px solid white !important;\r\n  padding-left: 7px !important;\r\n}\r\n\r\n/* Hide submenu icons if reference has text-only submenu */\r\n.sidebar-container .sidebar-submenu .sidebar-menu-icon {\r\n  display: none !important;\r\n}\r\n\r\n/* Logo should not shrink when submenu opens */\r\n.sidebar-logo-wrapper {\r\n  flex-shrink: 0 !important;\r\n  min-height: 140px !important;\r\n}\r\n\r\n\r\n/* Show complete sidebar menu text */\r\n.sidebar-container .sidebar-menu-text {\r\n  flex: 1;\r\n  min-width: 0;\r\n\r\n  color: #ffffff !important;\r\n  font-size: 13px !important;\r\n  font-weight: 600 !important;\r\n\r\n  white-space: normal !important;\r\n  overflow: visible !important;\r\n  text-overflow: unset !important;\r\n\r\n  line-height: 1.3;\r\n  overflow-wrap: break-word;\r\n}\r\n\r\n/* Allow menu items to expand for wrapped text */\r\n.sidebar-container .sidebar-menu-link {\r\n  height: auto !important;\r\n  min-height: 48px !important;\r\n\r\n  padding: 9px 13px !important;\r\n\r\n  box-sizing: border-box !important;\r\n}\r\n\r\n/* Keep icons aligned */\r\n.sidebar-container .sidebar-menu-icon {\r\n  flex-shrink: 0 !important;\r\n}\r\n\r\n/* Keep arrow at the right */\r\n.sidebar-container .sidebar-menu-arrow {\r\n  flex-shrink: 0 !important;\r\n  margin-left: auto;\r\n}\r\n\r\n\r\n/* Center menu tabs horizontally */\r\n.sidebar-container .sidebar-menu-list {\r\n  padding-left: 0 !important;\r\n  padding-right: 0 !important;\r\n\r\n  align-items: center !important;\r\n}\r\n\r\n/* Center each menu tab */\r\n.sidebar-container .sidebar-menu-item {\r\n  width: 86% !important;\r\n  margin-left: auto !important;\r\n  margin-right: auto !important;\r\n}\r\n\r\n/* Keep menu content aligned inside the tab */\r\n.sidebar-container .sidebar-menu-link {\r\n  width: 100% !important;\r\n  margin: 0 !important;\r\n  box-sizing: border-box !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
